module.exports = __webpack_public_path__ + "media/images/expand-ddc2ffa068547e0bc3d8cc9f518ce6b3.svg";